import React from "react";

const Map = () => {
    return (
        <div style={{ width: "100%" }}>
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d400356.7319252576!2d-121.4451245!3d38.37704934999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2cac5582c6886989%3A0x79a875d5f6332368!2sGolden%20State%20Movers!5e0!3m2!1sen!2sin!4v1736864803171!5m2!1sen!2sin"
                width="100%"
                height="200px"
                style={{ border: 0 }}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
            <br />
            <br />
            <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d405814.01712332026!2d-121.93850305000001!3d37.37985105!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd6284b9341f839%3A0x2c2b9bddda636546!2sGolden%20State%20Movers!5e0!3m2!1sen!2sin!4v1736865024866!5m2!1sen!2sin"
                width="100%"
                height="200px"
                style={{ border: 0 }}
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
        </div>
    );
}

export default Map;